import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-growth',
  templateUrl: './icon-growth.component.html',
  styles: []
})
export class IconGrowthComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
